
<div>
  <slot></slot>
  <template v-for="(propertyUpdate,  index) in objectModelAction.propertyUpdatesArray">
    <configure-property-update
      :deleteable="index !== 0"
      :key="propertyUpdate.property_client_id"
      :property-update="propertyUpdate"
      :property-options="updateableProperties"
      propertyLabel="Which property would you like to change?"
      valueLabel="Change to which value?"
      v-on:remove="removePropertyUpdate(propertyUpdate)"
      :fullWidth="false"
    >
      <template v-if="propertyUpdate.property_client_id">
        <component
          v-if="isPickList(propertyUpdate.property_client_id)"
          :is="getComponentForPropertyType(getObjectModelPropertyType(propertyUpdate.property_client_id))"
          :id="`update_value_${propertyUpdate.property_client_id}`"
          :key="`update_value_${propertyUpdate.property_client_id}`"
          class="skip-drag"
          :property-client-id="propertyUpdate.property_client_id"
          :object-model="selectedObjectModel"
          v-bind="getAdditionalAttrs(getObjectModelProperty(propertyUpdate.property_client_id))"
          v-model="propertyUpdate.values_to_update_to_array"
        ></component>
        <component
          v-else
          :is="getComponentForPropertyType(getObjectModelPropertyType(propertyUpdate.property_client_id))"
          :id="`update_value_${propertyUpdate.property_client_id}`"
          :key="`update_value_${propertyUpdate.property_client_id}`"
          class="skip-drag"
          :property-client-id="propertyUpdate.property_client_id"
          :object-model="selectedObjectModel"
          v-bind="getAdditionalAttrs(getObjectModelProperty(propertyUpdate.property_client_id))"
          v-model="propertyUpdate.value_to_update_to"
        ></component>
      </template>
    </configure-property-update>

  </template>
  <div class="cta">
    <button @click="addPropertyUpdate" type="button" class="btn grey-to-blue full-sz" id="add-property-update">
      + Add Another
    </button>
  </div>
</div>
